var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.41375,73.5865 C77.19475,74.3675 77.19475,75.6335 76.41375,76.4145 C76.02275,76.8055 75.51175,77.0005 74.99975,77.0005 C74.48775,77.0005 73.97575,76.8055 73.58575,76.4145 L47.99975,50.8285 L22.41375,76.4145 C22.02375,76.8055 21.51175,77.0005 20.99975,77.0005 C20.48775,77.0005 19.97575,76.8055 19.58575,76.4145 C18.80475,75.6335 18.80475,74.3675 19.58575,73.5865 L45.17175,48.0005 L19.58575,22.4145 C18.80475,21.6335 18.80475,20.3665 19.58575,19.5865 C20.36575,18.8045 21.63275,18.8045 22.41375,19.5865 L47.99975,45.1725 L73.58575,19.5865 C74.36675,18.8045 75.63275,18.8045 76.41375,19.5865 C77.19475,20.3665 77.19475,21.6335 76.41375,22.4145 L50.82775,48.0005 L76.41375,73.5865 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgClose;